import { render, staticRenderFns } from "./LogoSplash.vue?vue&type=template&id=0f58620c&scoped=true&lang=pug&"
import script from "./LogoSplash.vue?vue&type=script&lang=ts&"
export * from "./LogoSplash.vue?vue&type=script&lang=ts&"
import style0 from "./LogoSplash.vue?vue&type=style&index=0&id=0f58620c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f58620c",
  null
  
)

export default component.exports